
import Vue from 'vue';
import InfoSferumWebinar from '@/pages/profile/components/infoSferum/InfoSferumWebinar.vue';
import AppButtonNew from '@/uikit/components/AppButtonNew/AppButtonNew.vue';
import { ButtonType } from '@/uikit/components/AppButtonNew/defaultConfigs';

export default Vue.extend({
  name: 'SferumWebinarGroup',
  components: { AppButtonNew, InfoSferumWebinar },
  props: {
    group: Object as any,
  },
  computed: {
    getButtonType() {
      return ButtonType;
    },
    getChildren() {
      return [...this.group.children].sort((el1, el2) => {
        if (el1.status_rus === 'Завершен' && el2.status_rus !== 'Завершен') {
          return 1;
        }
        if (el1.status_rus === 'Завершен' && el2.status_rus === 'Завершен') {
          return 0;
        } else {
          return -1;
        }
      });
    },
  },
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/infoSferum/SferumWebinarGroup.vue